import { Instagram, Facebook, Youtube, Music as MusicIcon, Mail } from "lucide-react";

const SOCIALS = [
  {
    key: "spotify",
    label: "Spotify",
    href: "https://open.spotify.com/artist/5uWPXaWt5DUvDxDpFlcb1Z",
    icon: MusicIcon,
    note: "Now Streaming",
  },
  {
    key: "youtube",
    label: "YouTube",
    href: "https://www.youtube.com/@awiderhorizonmusic",
    icon: Youtube,
    note: "Videos & sessions",
  },
  {
    key: "instagram",
    label: "Instagram",
    href: "https://www.instagram.com/awiderhorizonmusic/",
    icon: Instagram,
    note: "Behind the scenes",
  },
  {
    key: "facebook",
    label: "Facebook",
    href: "https://www.facebook.com/AWiderHorizon/",
    icon: Facebook,
    note: "News & Updates",
  },
  {
    key: "tiktok",
    label: "TikTok",
    href: "https://www.tiktok.com/@awiderhorizon",
    // tiktok icon via Music icon fallback would be misleading; use a simple letter mark
    icon: null,
    note: "Short cuts",
  },
];

export default function Connect() {
  return (
    <section
      id="connect"
      data-testid="connect-section"
      className="relative bg-ivory py-28 md:py-36 lg:py-44 px-6 md:px-12 lg:px-20"
    >
      <div className="mx-auto max-w-[1400px]">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-y-16 lg:gap-x-20">
          <div className="lg:col-span-4 reveal">
            <p className="text-[10px] uppercase tracking-[0.32em] text-teal mb-6">
              Connect
            </p>
            <h2 className="font-serif font-light text-4xl md:text-5xl leading-[1.05] tracking-tight text-ink">
              Find the project
              <br />
              <em className="italic text-gold">in the wild.</em>
            </h2>
            <div className="ink-divider mt-10" />
            <a
              data-testid="contact-email-link"
              href="mailto:jacob@jacobsealmusic.com"
              className="mt-10 inline-flex items-center gap-3 text-base md:text-lg font-light text-ink hover:text-teal transition-colors group"
            >
              <Mail strokeWidth={1.25} className="w-4 h-4" />
              <span className="link-underline">jacob@jacobsealmusic.com</span>
            </a>
          </div>

          <div className="lg:col-span-7 lg:col-start-6">
            <ul className="divide-y divide-ink/10 border-t border-b border-ink/10">
              {SOCIALS.map((s) => {
                const Icon = s.icon;
                return (
                  <li key={s.key} className="reveal">
                    <a
                      data-testid={`social-link-${s.key}`}
                      href={s.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="group flex items-center justify-between gap-6 py-7 md:py-8 transition-colors"
                    >
                      <div className="flex items-center gap-5 md:gap-7 min-w-0">
                        <span className="w-8 h-8 inline-flex items-center justify-center text-ash group-hover:text-gold transition-colors">
                          {Icon ? (
                            <Icon strokeWidth={1.25} className="w-5 h-5" />
                          ) : (
                            <span className="font-serif text-xl italic">
                              t
                            </span>
                          )}
                        </span>
                        <span className="font-serif text-2xl md:text-3xl font-light text-ink group-hover:text-teal transition-colors truncate">
                          {s.label}
                        </span>
                      </div>
                      <div className="flex items-center gap-6">
                        <span className="hidden md:inline text-[11px] uppercase tracking-[0.24em] text-ash">
                          {s.note}
                        </span>
                        <span
                          aria-hidden="true"
                          className="inline-block w-8 h-px bg-ink/40 group-hover:w-14 group-hover:bg-gold transition-all duration-500"
                        />
                      </div>
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
